import { useRoute } from 'vue-router';

// Session storage key read by useCreditEngine's getQuickRegisterParams()
const QUICK_REGISTER_QUERY_PARAMS_SESSION_KEY = 'quickRegisterQueryParams';
const COOKIE_NAME = 'creditGatewayReq';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  if (!route.path.startsWith('/my-credit')) return;

  // Read the short-lived cookie set by the server POST handler
  const raw = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${COOKIE_NAME}=`))
    ?.split('=')
    .slice(1)
    .join('=');

  if (!raw) return;

  try {
    const req = JSON.parse(decodeURIComponent(raw));
    const filteredReq = Object.fromEntries(Object.entries(req).filter(([_, value]) => value !== '' && value !== null && value !== undefined));

    sessionStorage.setItem(QUICK_REGISTER_QUERY_PARAMS_SESSION_KEY, JSON.stringify(filteredReq));
  } catch {
    // malformed cookie — ignore
  } finally {
    // Clear the cookie immediately after reading
    document.cookie = `${COOKIE_NAME}=; Max-Age=0; path=/`;
  }
});
